import { observer } from 'mobx-react';
import React from 'react';

import Async from 'components/Async';
import GradeBookGrid from 'components/GradeGrid';

import { useCalendarContext } from './Context';
import GradeBookMonthHeader from './Header';
import { Wrapper } from './styled';

function GradeBreakdown() {
	const { studentGrades, selectedPrograms } = useCalendarContext();

	const selectedProgramsIds = selectedPrograms.map((program) => program.program_group_id);

	return (
		<Wrapper>
			<GradeBookMonthHeader />
			<Async loading={studentGrades.loading}>
				<GradeBookGrid studentGrades={studentGrades} programsIds={selectedProgramsIds} />
			</Async>
		</Wrapper>
	);
}

export default observer(GradeBreakdown);
